import { render, staticRenderFns } from "./Category2.vue?vue&type=template&id=4f9056ba&scoped=true"
import script from "./Category2.vue?vue&type=script&lang=js"
export * from "./Category2.vue?vue&type=script&lang=js"
import style0 from "./Category2.vue?vue&type=style&index=0&id=4f9056ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9056ba",
  null
  
)

export default component.exports